import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=012adb43"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012adb43')) {
      api.createRecord('012adb43', component.options)
    } else {
      api.reload('012adb43', component.options)
    }
    module.hot.accept("./AdminProfile.vue?vue&type=template&id=012adb43", function () {
      api.rerender('012adb43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/AdminProfile.vue"
export default component.exports